// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"a78f6cba","312":"baa19b8b","573":"7f4ca837","757":"e966a03f"}[chunkId] + ".chunk.css";
};